import 'aframe';
import PropTypes from 'prop-types';
import Hotspot from '../../components/HotspotCmp';
import info from '../../icons/info-circle-solid.svg';
import cart from '../../icons/shopping-cart-plus.png';
import arrow from '../../icons/arrow.png';
import spot from '../../icons/spot.png'
import mac from "./imgs/mac.jpg";
import piano from "./imgs/piano.jpg";
import recording from "./imgs/recording.jpg";
import shelves from "./imgs/shelves.jpg";
import tshirt from "./imgs/tshirt.jpg";
import keyboard from "./imgs/keyboard.jpg";

const MSScene = ({ id, hotspots, xRotation, yRotation, zRotation }) => {
  return (
    <a-scene cursor="rayOrigin: mouse">
      <a-assets>
        <img id="ms-mac" src={mac} />
        <img id="ms-piano" src={piano} />
        <img id="ms-recording" src={recording} />
        <img id="ms-shelves" src={shelves} />
        <img id="ms-tshirt" src={tshirt} />
        <img id="ms-keyboard" src={keyboard} />
        <img id="info" src={info} />
        <img id="cart" src={cart} />
        <img id="arrow" src={arrow} />
        <img id="spot" src={spot} />
      </a-assets>
      <a-sky src={`#${id}`} rotation={`${xRotation} ${yRotation} ${zRotation}`} />
      
      <a-camera />

      {hotspots && hotspots.map((hotspot, i) => (
        <Hotspot
          key={i}
          type={hotspot.type}
          radius={hotspot.radius}
          xPosition={hotspot.xPosition}
          yPosition={hotspot.yPosition}
          zPosition={hotspot.zPosition}
          xRotation={hotspot.xRotation}
          yRotation={hotspot.yRotation}
          zRotation={hotspot.zRotation}
          text={hotspot.text}
          img={hotspot.img}
          link={hotspot.link}
          productId={hotspot.productId}
          raycaster="objects: .clickable"
        />
      ))}
    </a-scene>
  );
}

MSScene.propTypes = {
  id: PropTypes.string.isRequired,
  hotspots: PropTypes.array,
  xRotation: PropTypes.number,
  yRotation: PropTypes.number,
  zRotation: PropTypes.number,
}

MSScene.defaultProps = {
  id: 'scene',
  hotspot: false,
  xRotation: 0,
  yRotation: 0,
  zRotation: 0,
}

export default MSScene;
